import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-left text-black text-[1.2rem] sm:text-[1.2rem] font-bold" }
const _hoisted_2 = { class: "text-black text-[1.0rem] font-normal" }
const _hoisted_3 = { class: "text-left font-manrope font-medium leading-tight max-w-sm sm:text-[1.6rem] md:text-[1.6rem]" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DoctorImage = _resolveComponent("DoctorImage")!
  const _component_DoctorRating = _resolveComponent("DoctorRating")!
  const _directive_safe_html = _resolveDirective("safe-html")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_DoctorImage, {
      image: $props.data.image,
      name: $props.data.title
    }, null, 8, ["image", "name"]),
    _createElementVNode("div", null, [
      _createVNode(_component_DoctorRating, { reviews: [{ rating: 5 }] }),
      _createElementVNode("h5", _hoisted_1, [
        _createTextVNode(_toDisplayString($props.data.title) + " ", 1),
        _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
        _withDirectives(_createElementVNode("span", _hoisted_2, null, 512), [
          [_directive_safe_html, $props.data.smallText]
        ])
      ]),
      _withDirectives(_createElementVNode("span", _hoisted_3, null, 512), [
        [_directive_safe_html, $props.data.text]
      ])
    ])
  ], 64))
}